import { CountryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCountry(): Observable<CountryDto[]> {
    return this.http.get<CountryDto[]>(this.url + 'country');
  }

  createCountry(data: CountryDto[]): Observable<CountryDto[]> {
    return this.http.post<CountryDto[]>(this.url + 'country', data);
  }
  getSingleCountry(id: string): Observable<any> {
    return this.http.get(this.url + 'country/' + id);
  }

  updateCountry(data: CountryDto[]): Observable<CountryDto[]> {
    return this.http.post<CountryDto[]>(this.url + 'country/update', data);
  }

  deleteCountry(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('country', ids.join(', '));
    return this.http.delete(this.url + 'country', httpOptions);
  }
}
